import { render, staticRenderFns } from "./AboutUsSection.vue?vue&type=template&id=278cd072&"
import script from "./AboutUsSection.vue?vue&type=script&lang=js&"
export * from "./AboutUsSection.vue?vue&type=script&lang=js&"
import style0 from "./AboutUsSection.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports